import { Controller } from '@hotwired/stimulus';

export default class InvestmentExperienceController extends Controller {
  static values = { hasExperience: Boolean };
  static targets = ['professionalActivity', 'topExecutive'];

  hasExperienceValueChanged(hasExperience) {
    this.#toggleFields(this.professionalActivityTarget, hasExperience);
    this.#toggleFields(this.topExecutiveTarget, !hasExperience);
  }

  toggle(event) {
    this.hasExperienceValue = (event.target.value === 'true');
  }

  #toggleFields(container, shown) {
    container.classList.toggle('d-none', !shown);
    container.querySelectorAll('input').forEach(field => {
      field.disabled = !shown;
      if (shown) return;

      if (field.type === 'checkbox' || field.type === 'radio') {
        field.checked = false;
      } else {
        field.value = '';
      }
    });
  }
}
